<template>
  <el-form ref="formCardSanctions" :model="formData" label-position="top" size="mini">
    <el-card style="height: 100%">
      <div slot="header" class="clearfix">
        <el-row :gutter="5" align="middle" justify="space-between" type="flex">
          <el-col :span="6">
            <span class="font-weight-bold"> Sanciones del taxi </span>
          </el-col>

          <template v-if="isNew">
            <el-col :span="4">
              <workgroup-central-selector
                v-model="formGetTaxi.selectedWgCentral"
                :allow-select-workgroups="false"
                :allowSelectMultipleCentrals="false"
                :allowSelectMultipleWorkgroups="false"
              />
            </el-col>

            <el-col :span="4">
              <el-input
                v-model="formGetTaxi.license"
                placeholder="Buscar por licencia"
                size="mini"
                @blur="onChangeLicense"
                v-on:keyup.enter.native="$event.target.blur()"
              />
            </el-col>
          </template>

          <el-col :span="10" class="text-right">
            <el-button-group>
              <el-button
                :disabled="isFormEqualsToInitialSanction || isDisabled"
                size="mini"
                type="primary"
                @click="onUpdateSanction"
              >
                Actualizar
              </el-button>
              <el-button
                :disabled="isFormEqualsToInitialSanction || isDisabled"
                icon="el-icon-close"
                size="mini"
                type="info"
                @click="onCancel"
              >
                Cancelar
              </el-button>
            </el-button-group>
          </el-col>
        </el-row>
      </div>

      <div class="card-taxi__body">
        <el-row :gutter="5">
          <el-col :span="5">
            <el-form-item label="Tipo de sanción">
              <el-select
                v-model="formData.appliedSanction"
                :class="{
                  'select-background-green': formData.appliedSanction === 1,
                  'select-background-red':
                    formData.appliedSanction && formData.appliedSanction !== 1,
                }"
                :disabled="isDisabled"
                placeholder="Selecciona un tipo"
                @change="onChangeAppliedSanction"
              >
                <el-option
                  v-for="op in appliedSanctionOptions"
                  :key="op.value"
                  :label="op.label"
                  :value="op.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="19">
            <el-form-item label="Sanciones predefinidas">
              <el-radio-group
                v-model="customOptionTime"
                :disabled="formData.appliedSanction === 1 || isDisabled || isNonPayment"
                @change="onChangeCustomOptionTime"
              >
                <el-radio-button label="Manual" />
                <el-radio-button :label="15">15m</el-radio-button>
                <el-radio-button :label="60">1h</el-radio-button>
                <el-radio-button :label="120">2h</el-radio-button>
                <el-radio-button :label="180">3h</el-radio-button>
                <el-radio-button :label="240">4h</el-radio-button>
                <el-radio-button :label="300">5h</el-radio-button>
                <el-radio-button :label="360">6h</el-radio-button>
                <el-radio-button :label="480">8h</el-radio-button>
                <el-radio-button :label="1440">24h</el-radio-button>
                <el-radio-button :label="2880">48h</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="5" class="my-2">
          <el-col :span="8" :validations="$v.formData.sanctionFrom">
            <el-form-item :class="{ 'is-error': $v.formData.sanctionFrom.$error }" label="Empieza">
              <DatePickerFromFuture
                v-model="$v.formData.sanctionFrom.$model"
                :disabled="formData.appliedSanction === 1 || isDisabled"
                @change="onChangeDatePicker"
              />
              <div
                v-if="!$v.formData.sanctionFrom.required && $v.formData.sanctionFrom.$dirty"
                class="el-form-item__error"
              >
                El campo es obligatorio
              </div>
              <div
                v-else-if="
                  !$v.formData.sanctionFrom.afterSanctionTo && $v.formData.sanctionFrom.$dirty
                "
                class="el-form-item__error"
              >
                No puede ser posterior a la fecha de "Finaliza"
              </div>
            </el-form-item>
          </el-col>

          <el-col :span="8" :validations="$v.formData.sanctionTo">
            <el-form-item :class="{ 'is-error': $v.formData.sanctionTo.$error }" label="Finaliza">
              <DatePickerToFuture
                v-model="$v.formData.sanctionTo.$model"
                :disabled="formData.appliedSanction === 1 || isDisabled || isNonPayment"
                @change="onChangeDatePicker"
              />
              <div
                v-if="!$v.formData.sanctionTo.required && $v.formData.sanctionTo.$dirty"
                class="el-form-item__error"
              >
                El campo es obligatorio
              </div>
              <div
                v-else-if="
                  !$v.formData.sanctionTo.beforeSanctionFrom && $v.formData.sanctionTo.$dirty
                "
                class="el-form-item__error"
              >
                No puede ser anterior a la fecha de "Empieza"
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="5" class="mt-2">
          <el-col :span="24">
            <el-form-item label="Texto">
              <el-input
                v-model="formData.sanctionText"
                :disabled="formData.appliedSanction === 1 || isDisabled"
                :rows="3"
                placeholder="Escribe una nota"
                type="textarea"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <!-- {{ taxi.sanctionData }}
        <hr />
        {{ formData.sanctionData }} -->
        <!-- {{ $v }} -->
      </div>
    </el-card>
  </el-form>
</template>

<script>
import { mapGetters } from "vuex";
import { requiredIf } from "vuelidate/lib/validators";
import WorkgroupCentralSelector from "@/components/common/forms/WorkgroupCentralSelector.vue";
import DatePickerFromFuture from "@/components/common/forms/DatePickerFromFuture.vue";
import DatePickerToFuture from "@/components/common/forms/DatePickerToFuture.vue";
import { getUnixTimeInSeconds } from "@/utils/date";
import moment from "@/utils/moment";

const NON_PAYMENT = 5;

export default {
  name: "CardSanctions",

  mixins: [import("@/mixins/cache")],

  components: {
    WorkgroupCentralSelector,
    DatePickerFromFuture,
    DatePickerToFuture,
  },

  props: {
    isNew: {
      type: Boolean,
      default: false,
    },
    taxi: {
      type: Object,
      default: () => {},
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      formGetTaxi: {
        selectedWgCentral: null,
        license: "",
      },
      formData: {
        appliedSanction: null,
        sanctionFrom: null,
        sanctionTo: null,
        sanctionText: "",
      },
      optionsPicker: {
        disabledDate(time) {
          let d = new Date();
          var yesterday = new Date(d);
          yesterday.setDate(yesterday.getDate() - 1);
          return time.getTime() < yesterday;
        },
      },
      customOptionTime: "Manual",
    };
  },

  validations() {
    if (this.appliedSanction !== 0) {
      return {
        formData: {
          sanctionFrom: {
            required: requiredIf((formData) => {
              return formData.appliedSanction !== 1;
            }),
            afterSanctionTo: (val) => {
              if (!this.formData.sanctionTo) {
                return true;
              }
              if (val > this.formData.sanctionTo) {
                return false;
              } else {
                return true;
              }
            },
          },
          sanctionTo: {
            required: requiredIf((formData) => {
              return formData.appliedSanction !== 1 && formData.appliedSanction !== NON_PAYMENT;
            }),
            beforeSanctionFrom: (val) => {
              if (this.formData.appliedSanction === NON_PAYMENT) {
                return true;
              }
              if (!this.formData.sanctionFrom) {
                return true;
              }
              if (val < this.formData.sanctionFrom) {
                return false;
              } else {
                return true;
              }
            },
          },
        },
      };
    }
  },

  computed: {
    ...mapGetters("app", ["defaultSelectedWorkgroupAndCentral"]),

    isFormEqualsToInitialSanction() {
      return JSON.stringify(this.taxi.sanctionData) === JSON.stringify(this.formData);
    },

    isNonPayment() {
      return this.formData.appliedSanction === NON_PAYMENT;
    },

    appliedSanctionOptions() {
      if (this.taxi.selectsFormsFieldsOptions) {
        return this.taxi.selectsFormsFieldsOptions.appliedSanction;
      } else {
        return [];
      }
    },
  },

  watch: {
    taxi(newVal) {
      if (newVal) {
        this.formData = JSON.parse(JSON.stringify(newVal.sanctionData));
        this.calculateCustomOption();
        this.$v.$reset();
      }
    },
  },

  created() {
    if (this.isNew) {
      this.formGetTaxi.selectedWgCentral = this.defaultSelectedWorkgroupAndCentral;
    }
  },

  methods: {
    onUpdateSanction() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$message({
          type: "error",
          message: "Hay fallos en el formulario",
        });
      } else {
        if (this.isNonPayment) {
          this.formData.sanctionTo = getUnixTimeInSeconds(moment()().add(1, "year"));
        }
        this.$emit("update-sanction", this.formData);
        this.customOptionTime = "Manual";
      }
    },

    onCancel() {
      this.formData = JSON.parse(JSON.stringify(this.taxi.sanctionData));
      this.$v.$reset();
    },

    onChangeAppliedSanction(value) {
      if (value === 1) {
        this.formData = {
          appliedSanction: 1,
          sanctionFrom: null,
          sanctionTo: null,
          sanctionText: "",
        };
      } else {
        this.customOptionTime = "Manual";
      }
    },

    onChangeCustomOptionTime(option) {
      if (option !== "Manual") {
        this.formData.sanctionFrom = new Date().getTime();
        this.formData.sanctionTo = new Date().getTime() + option * 60000;
      } else {
        this.formData.sanctionFrom = null;
        this.formData.sanctionTo = null;
        this.$v.$reset();
      }
    },

    onChangeDatePicker() {
      this.customOptionTime !== "Manual"
        ? (this.customOptionTime = "Manual")
        : this.customOptionTime;

      this.calculateCustomOption();
    },

    calculateCustomOption() {
      let hours = Math.floor((this.formData.sanctionTo - this.formData.sanctionFrom) / 1000 / 3600);
      if (hours > 48) {
        this.customOptionTime = "Manual";
      } else {
        this.customOptionTime = hours;
      }
    },

    onChangeLicense() {
      this.$emit("find-taxi", this.formGetTaxi);
    },
  },
};
</script>
